export default "__VITE_ASSET__Cp77K9bg__"